
import React from 'react';

export const Hero: React.FC = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center px-4 overflow-hidden bg-slate-950">
      {/* Background glow to match Waitlist style */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[500px] bg-indigo-600/10 blur-[120px] rounded-full pointer-events-none"></div>
      
      <div className="max-w-7xl mx-auto text-center relative z-10 py-20">
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold tracking-tight mb-8 leading-tight max-w-5xl mx-auto">
          Construindo <br />
          <span className="gradient-text block mt-2">competências para o futuro</span>
        </h1>
        <p className="text-lg md:text-xl text-slate-400 max-w-3xl mx-auto mb-10 leading-relaxed">
          Desenvolva autonomia e domine competências técnicas e socioemocionais que serão relevantes para o futuro!
        </p>
      </div>
    </section>
  );
};
